import { getNodeDeserializer } from './getNodeDeserializer.mjs';

/**
 * See {@link getNodeDeserializer}.
 */
const getLeafDeserializer = options => getNodeDeserializer({
  node: () => ({
    [options.type]: true
  }),
  ...options
});

export { getLeafDeserializer };
